module.exports = {
    GUESTHOUSE: {
        id: "7",
        name: "guesthouse",
        bank: "Stanbic IBTC",
        accountName : 'Total E & P Cooperative',
        accountNumber: "0014740829",
    
      },

      GUESTHOUSE_EMAIL : 'guesthouse@totalupstreamng.coop',
 
}